import type { TenantCustomizations } from "src/tenantCustomizations/TenantCustomizations";
import React from "react";
import { useContextOrThrow } from "src/utils/useContextOrThrow.tsx";

export const TenantCustomizationsContext = React.createContext<TenantCustomizations | undefined>(undefined);

export const useTenantCustomizations = () => useContextOrThrow(TenantCustomizationsContext);
